import React, { useContext, useEffect, useState } from 'react'
import './StarlineResult.css'
import CurrentDayTime from '../14-currentDate/CurrentDayTime'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { LoaderContext } from '../15-loader/LoaderProvider'


const StarlineResult = () => {

    const navigate = useNavigate()

    const [starlineApiData, setStarlineApiData] = useState([]);
    const { setIsLoading } = useContext(LoaderContext);

    const getStarline = async () => {
        await axios.get(`${process.env.REACT_APP_BASE_URL}/web/getStarlineMarkets`)
            .then((r) => {
                setStarlineApiData(r.data.data);
                setIsLoading(false)
            })
            .catch((err) => console.log(err.message));
    }

    useEffect(() => {

        getStarline()
    }, []);

    function sumGetLastDigit(value) {

        if (value == null) {
            return null;
        } else {
            return (
                value
                    .toString()
                    .split('')
                    .map(Number)
                    .reduce(function (a, b) {
                        return a + b;
                    }, 0) % 10
            );
        }
    }

    return (

        <div className='starline-result'>

            <div className='starline-result-content'>

                <div className='container'>

                    <div className='starline-result-heading' ><h2>LATA 777 STARLINE GAMES</h2></div>

                    <div className='starline-chart-zone'>
                    
                        <div className='chart-zone-button btn' onClick={() => navigate('/starline')}>STARLINE CHART</div>
                    
                    </div>

                    <div className='starline-result-boxes'>

                        {
                            starlineApiData.map((data) =>

                                <div className='starline-result-box' key={data.id}>

                                    <div className='starline-result-time'><h2>{data.Time ? data.Time : '-'}</h2></div>
                                    <div className='starline-star-result'>

                                        <h2>
                                            {data.Result ? data.Result : <div className='star'>***</div>}
                                            <span className='dash'><hr /></span>
                                            {data?.Result ? sumGetLastDigit(data?.Result) : <div className='star'>*</div>}
                                        </h2>

                                    </div>

                                </div>

                            )

                        }

                    </div>

                </div>

            </div>

        </div>
    )
}

export default StarlineResult
